import { TrafficLightSectionDetail } from '@cloudmatize/traffic-hub'

export function TrafficLightSectionDetailPage() {
  return <TrafficLightSectionDetail />
}
